#import "~/graphql/fragments/contentBuilder/contentBlocks.graphql"
#import "~/graphql/fragments/sections/programmes/programmePreview.graphql"
#import "~/graphql/fragments/seo/index.graphql"
#import "~/graphql/fragments/fields/tags.graphql"
#import "~/graphql/fragments/assets/image.graphql"
#import "~/graphql/fragments/fields/media.graphql"
#import "~/graphql/fragments/fields/showcaseButton.graphql"
#import "~/graphql/fragments/sections/grants-issued/grantIssuedSection.graphql"

fragment programmeSection on programme_Entry {
    ... programmePreview
    tags {
        ... tags
    }
    contentBlocks {
        ... contentBlocks
    }
    seo {
        ... socialFragment
    }
    heroImages {
        ... image
    }
    showcaseActive
    showcaseTitle
    showcaseDescription
    showcaseBackgroundColor
    showcaseTextColor
    showcaseLabel {
        title
    }
    showcaseLabelStyle
    media {
        ... media
    }
    showcaseButton {
        ... showcaseButton
    }
    showcaseGrants {
        ... on grantIssued_Entry {
            ... grantIssuedSection
        }
    }
}
